import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const CheckOutlined = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <g>
        <path d="M4.48 7.68L1.92 5.12 0 7.04l4.48 4.48L12.8 3.2l-1.92-1.92z" transform="translate(1.5 1.5)" />
      </g>
    </svg>
  );
};

CheckOutlined.displayName = 'CheckOutlined';
